import { isNaN } from '../utils/validate/number';
export function times(n, iteratee) {
  if (n < 0) {
    return [];
  }

  var index = -1;
  var result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }

  return result;
}
export function getTrueValue(value) {
  if (!value) {
    return 0;
  }

  while (isNaN(parseInt(value, 10))) {
    if (value.length > 1) {
      value = value.slice(1);
    } else {
      return 0;
    }
  }

  return parseInt(value, 10);
}
export function getMonthEndDay(year, month) {
  return 32 - new Date(year, month - 1, 32).getDate();
}


//////////////////
// WEBPACK FOOTER
// ./~/vant/es/datetime-picker/utils.js
// module id = 42
// module chunks = 74